import React from "react";
import { useTranslation } from "react-i18next";
import Colors from "../Constants/Color";
import ScrollAnimation from "react-animate-on-scroll";
const PrivacyPolicy = () => {
  const { t } = useTranslation();
  const PrivacyPolicydata = [
    {
      first: "Privacy Policy",
      second: "Privacy and Data Protection",
      third:
        "Your personal information is protected and will not be sold or disclosed to third parties for commercial purposes. It will only be used in accordance with our privacy policy and applicable laws.",
    },
    {
      third:
        "By using KŌZĒ services and properties, you acknowledge that you have read, understood, and agree to these terms and conditions.",
    },

    {
      second: "SMS Privacy Policy",
      third:
        "By opting in to receive SMS messages from KŌZĒ, you consent to receive marketing and informational text messages, including promotions, updates, and offers related to our services. Message frequency may vary.",
    },
    {
      fourth: "Data Usage : ",
      fifth:
        "We collect and use your mobile number solely for the purpose of sending SMS communications you have agreed to receive. Your number will not be sold or shared with third parties for their marketing purposes.",
    },
    {
      fourth: "Opt-Out : ",
      fifth:
        "You may opt-out of SMS communications at any time by replying STOP to any message or contacting us directly. Once you opt-out, you will no longer receive SMS communications unless you re-subscribe.",
    },
    {
      fourth: "Standard Messaging Rates : ",
      fifth:
        "Standard message and data rates may apply based on your mobile carrier’s policies.",
    },
    {
      fourth: "Security : ",
      fifth:
        "We take measures to protect your personal information, including your mobile number, against unauthorized access and use.",
    },
  ];
  return (
    <div
      style={{
        padding: "40px 50px",
        backgroundColor: Colors.lightgoladn,
      }}
    >
      {PrivacyPolicydata.map((section, index) => (
        <div key={index}>
          <ScrollAnimation animateIn="bounceInRight">
            <h1
              style={{
                fontSize: "34px",
                fontWeight: "bold",
              }}
              className="cinzel text-left capitalize"
            >
              {t(section.first)}
            </h1>
          </ScrollAnimation>
          <ScrollAnimation animateIn="bounceInRight">
            <h1
              style={{
                fontSize: "22px",
                fontWeight: "semibold",
                fontWeight: "500",
                marginTop: "20px",
              }}
              className="Optima text-left capitalize"
            >
              {t(section.second)}
            </h1>
          </ScrollAnimation>
          <ScrollAnimation animateIn="bounceInLeft">
            <h1
              style={{
                fontSize: "15px",
                marginTop: "2px",
              }}
              className="Optima text-left"
            >
              {t(section.third)}
            </h1>
          </ScrollAnimation>
          {section.fourth && (
            <div style={{ marginLeft: "30px" }}>
              <ScrollAnimation
                style={{
                  display: "flex",
                  gap: "10px",
                  alignItems: "flex-start",
                  flexDirection: "row",
                }}
                animateIn="bounceInRight"
              >
                <ul style={{ listStyleType: "revert" }}>
                  <li>
                    <div
                      style={{
                        display: "block",
                        gap: "10px",
                        alignItems: "flex-start",
                        flexDirection: "row",
                        width: "100%",
                        flexWrap:'wrap'
                      }}
                    >
                      <h1
                        style={{
                          // fontSize: "15px",
                          // margin: 0,

                          fontSize: "15px",
                          fontWeight: 700,
                          whiteSpace: "nowrap",
                        }}
                        className="Optima text-left capitalize"
                      >
                        {t(section.fourth)}
                      </h1>
                      <h1
                        style={{
                          fontSize: "15px",
                          margin: 0,
                        }}
                        className="Optima text-left"
                      >
                        {t(section.fifth)}
                      </h1>
                    </div>
                  </li>
                </ul>
              </ScrollAnimation>
            </div>
          )}
        </div>
      ))}
    </div>
  );
};

export default PrivacyPolicy;
